<template>
  <div v-if="list.length">
    <div class="lesson-header">
      <div class="lesson-header-left">
        <ym-img class="icon"
                :src="require('@/assets/img/course/title_try.png')"
        />
        <span>试听特辑</span>
      </div>
    </div>
    <div class="lesson-list">
      <router-link v-for="(item, index) in list"
                   :key="index"
                   :to="{ name: 'CourseTryDetail', params: { id: item.id } }"
                   class="lesson-list-item"
                   v-ym-report:COURSE_DETAIL_AUDITION_CLICK="{
                     location: 'courseDetailOutline',
                     auditionId: item.id,
                   }"
      >
        <div class="lesson-list-item-left">
          <div class="lesson-list-item-left-num">{{ index + 1 }}</div>
          <div class="lesson-list-item-left-info">
            <div class="lesson-list-item-left-info-top">
              {{ item.title }}
            </div>
            <div class="lesson-list-item-left-info-bottom">
              <ym-img class="icon"
                      :src="require('@/assets/img/course/try_video.png')"
              />
              <span>{{ item.durationDesc }}</span>
            </div>
          </div>
        </div>
        <div class="lesson-list-item-right">
          <ym-img class="icon"
                  :src="require('@/assets/img/course/try_play.png')"
          />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CourseDetailAuditionList',
    props: {
      list: {
        type: Array,
      },
    },
    data() {
      return {};
    },
    methods: {},
    created() {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .lesson {
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 32px;
      padding-right: 40px;
      height: 122px;
      &-left {
        display: flex;
        align-items: center;
        .icon {
          width: 33px;
          height: 22px;
          margin-right: 6px;
        }
        span {
          color: #222;
          font-size: 32px;
          font-weight: bold;
        }
      }
      &-right {
        width: 104px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #F5F6F7;
        color: @color-text-lighter;
        font-size: @font-size-small;
        border-radius: 13px;
        cursor: pointer;
      }
    }
    &-list {
      padding: 0 32px;
      border-bottom: 11px solid #f4f4f4;
      .lesson-list-item {
        display: flex;
        justify-content: space-between;
        padding: 40px 0;
        border-bottom: 1px solid #eee;
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          border-bottom: none;
        }
        &-left {
          display: flex;
          align-items: center;
          &-num {
            color: #ccc;
            font-size: 40px;
            font-weight: bold;
            margin-right: 10px;
          }
          &-info {
            display: flex;
            flex-direction: column;
            &-top {
              color: #222;
              font-size: 28px;
              font-weight: bold;
              line-height: 1;
              margin-bottom: 16px;
            }
            &-bottom {
              display: flex;
              align-items: center;
              .icon {
                width: 24px;
                height: 24px;
                margin-right: 8px;
              }
              span {
                color: #999;
                font-size: 24px;
              }
            }
          }
        }
        &-right {
          .icon {
            width: 64px;
            height: 64px;
          }
        }
      }
    }
  }
</style>
